module.exports = __webpack_public_path__ + "static/media/7.dae3916b.jpeg";